<template>
  <div class="title-main">
    <div class="title-content">
      <span
        class="title-en"
        v-if="enContent"
      >{{ enContent }}</span>
      <!-- <br /> -->
      <span
        class="title-zh"
        v-html="zhContent"
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    enContent: {
      type: String,
      default: ''
    },
    zhContent: {
      type: String,
      default: ''
    },
  }
}
</script>

<style lang='less' scoped>
.title-main {
  position: relative;
  width: 280px;
  height: 90px;
  background-color: rgba(2, 106, 179, 0.7);
  background: linear-gradient(135deg, transparent 45px, rgba(2, 106, 179, 0.7) 0) top left,
    linear-gradient(-135deg, transparent 45px, rgba(2, 106, 179, 0.7) 0) top right,
    linear-gradient(45deg, transparent 45px, rgba(2, 106, 179, 0.7) 0) bottom left,
    linear-gradient(-45deg, transparent 45px, rgba(2, 106, 179, 0.7) 0) bottom right;
  background-size: 50% 50%;
  background-repeat: no-repeat;
  text-align: center;
  font-weight: bold;
  color: #afdefa;
  text-shadow: 0 0 10px rgba(175, 222, 250, 0.5);
  z-index: 1;
  position: relative;
  .title-content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .title-en {
      font-size: 20px;
    }
    .title-zh {
      font-size: 28px;
    }
  }
  .fullScreen-btn {
    position: absolute;
    left: 50%;
    bottom: -32px;
    transform: translate(-50%);
    height: 32px;
    width: 153px;
    background-color: rgba(0, 0, 0, 0.7);
    color: #fa0031;
    outline: none;
    border-width: 0;
    text-align: center;
    cursor: pointer;
  }
}
</style>
